import React, { Component,Fragment } from 'react';
import { Breadcrumb, Row, List, Pagination, Spin, Input ,  Icon, Divider} from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { getAnnouncements } from '../../actions';
import { DEFAULT_IMG } from '../../utils/constants';

import moment from 'moment';
import { prepSearch } from '../../utils/params';

import Posts from '../Dashboard/Categories/Posts';

import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

import {loadJson} from '../../utils/loadjson';
const homeLayout = loadJson( '/assets/home.json');
const articleColumns = homeLayout.articleColumns;
const articleLines= homeLayout.articleLines;


const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

const Title = styled.h3`
  font-weight: 600;
  /* color: #FB5422; */
`;

const Info = styled.div `
  color: #FB5422;  
`;

const ArticleFeaturedImage = styled.div`
  overflow: hidden;
  background-size: cover;
  background-position: center;
  height: 160px;
  margin-top: 10px;
  background-color: #DEE4E8;
  background-image: url(${props => props.src || DEFAULT_IMG});
`;

class Category extends Component {
  state = {
    searchText: '',
  }

  componentDidMount() {
    this.props.getAnnouncements();
  }

  render() {
    const { locale, announcements, articlesLoading } = this.props;
    const articles = announcements;
    const sectionName = (<FormattedMessage id="Home.Announcements" />)

    {/* Begin=This part is used to render articles, the same between Announcement and Categories 
      variables must be prepared: sectionName, articles, articlesLoading, others are read at state
    */}
    const { userInfo } = this.props;  

    const { searchText } = this.state;
    const  myArticles = articles ? articles.filter(a => a.language === locale) : [];
    const filteredArticles = myArticles.map(article => ({
      _id: article._id,
      title: article.title,
      slug: article.slug,
      highlight: article.highlight,      
      date: moment(article.createdAt).format('Do MMMM YYYY, h:mm'),
      user: article.user,
    })).filter(item => !searchText || prepSearch(item.title).includes(prepSearch(searchText)));

    return (
      <div>
        <h2 style={{ marginTop: 15 }}>{sectionName}</h2>
        <Input.Search
          value={searchText}
          onChange={e => this.setState({ searchText: e.target.value })}
          placeholder="Tìm bài viết..."
          style={{ marginTop: 5, marginBottom: 20 }}
        />        
        <Row style={{ marginTop: 10, marginBottom: 10 }}>
          <List
            dataSource={filteredArticles}
            loading={articlesLoading && !filteredArticles.length}
            grid={{ gutter: 20, sm: 1, md: 2, xl: articleColumns }}
            renderItem={item => (
              <List.Item style={{ marginBottom: 10 }}>
                  <ArticleFeaturedImage src={item.featuredImage} />
                  <Info>
                  {item.date} 
                  { ((userInfo.role.includes(1) || userInfo.role.includes(17) || (item.user && userInfo._id === item.user._id)))
                   ? item.user && `-${item.user.lecturerId}` : "" 
                  }
                  { (userInfo.lecturerId === "admin")
                   ? 
                    <Fragment>
                     <Divider type="vertical" />                  
                      <a role='button' onClick={() => { this.handleEdit(item._id); }}><Icon type="edit" />{' '}</a>
                    </Fragment>                   
                   : "" 
                   }
                   </Info>
                <Link to={`/bai-viet/${item.slug}-${item._id}`}>
                 <Title style={{ marginTop: 5 ,marginBottom: 5, minHeight: 100 }}>
                 {
                  item.highlight ?
                    <div style={{ position: 'relative' }}>
                      <ResponsiveEllipsis
                        text={`‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎${item.title}`}
                        maxLine={`${articleLines}`}
                      />
                      <img alt="hot-news" src="/assets/images/hot-news.gif" style={{ position: 'absolute', top: 3, left: 0, width: 32, height: 16 }} />
                    </div>
                    : <ResponsiveEllipsis
                      text={item.title}
                        maxLine={`${articleLines}`}
                      />
                  }
                  </Title>
                </Link>
              </List.Item>
            )}
          />
        </Row>
        <Pagination   style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end'}} defaultCurrent={1} total={filteredArticles.length / 10} size={10} />
      </div>
    );
    {/* End=This part is used to render articles, the same between Announcement and Categories */}    
    
    
  }
  
  handleEdit = (key) => {
    const myPost = this.props.announcements.find(item => item._id === key);
    const postInstance = new Posts();
    postInstance.showEditor(myPost);
  }  
}

const mapStateToProps = state => ({
  article: state.article,
  userInfo: state.user.info,
});

export default connect(state => ({
  announcements: state.article.announcements,
  loading: state.article.loading,
  locale: state.intl.locale,
  userInfo: state.user.info,  
}), {
  getAnnouncements,
})(Category);



// WEBPACK FOOTER //
// ./src/screens/Announcement/Announcement.js